import React from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import esriStrings from '../../resources/esriStrings';
import './barchart.scss';
am4core.useTheme(am4themes_animated);
am4core.addLicense('CH87155574');

const initChart = (ref, data, numInital) => {
  const chart = am4core.create(ref, am4charts.XYChart);

  chart.data = data;
  chart.colors.list = [am4core.color('#c5e5f9'), am4core.color('#80bce0')];
  chart.padding(40, 0, 0, 0);

  const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
  categoryAxis.renderer.grid.template.location = 0;
  categoryAxis.dataFields.category = 'year';
  categoryAxis.renderer.inversed = false;
  categoryAxis.renderer.grid.template.disabled = true;
  categoryAxis.renderer.labels.template.disabled = true;
  categoryAxis.renderer.labels.template.fontSize = 1;

  const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
  valueAxis.min = 0;
  valueAxis.extraMax = 0;
  valueAxis.renderer.grid.template.disabled = true;
  valueAxis.renderer.labels.template.disabled = true;

  const series = chart.series.push(new am4charts.ColumnSeries());
  series.dataFields.categoryX = 'year';
  series.dataFields.valueY = 'val';
  series.tooltipText = '{valueY.value}';
  series.columns.template.strokeOpacity = 0;
  series.columns.template.fillColor = am4core.color('#5a5');
  series.columns.template.column.cornerRadiusTopRight = 10;
  series.columns.template.column.cornerRadiusTopLeft = 10;
  series.columns.template.width = am4core.percent(96);
  series.columns.template.fill = am4core.color('#5a5');
  const labelBullet = series.bullets.push(new am4charts.LabelBullet());
  labelBullet.label.verticalCenter = 'bottom';
  labelBullet.label.dy = 30;
  labelBullet.label.text = `{values.valueY.workingValue}${numInital}`;
  labelBullet.label.fill = am4core.color('#fff');
  labelBullet.label.fontSize = 13;

  labelBullet.label.fill = am4core.color('#000');

  chart.zoomOutButton.disabled = true;

  // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
  series.columns.template.adapter.add('fill', (fill, target) =>
    chart.colors.getIndex(target.dataItem.index)
  );

return chart;
};

const BarChart = (props) => {
  const chartRef = React.useRef();
  const defaultData = props.data
    ? props.data
    : [
        {
          year: 'Current',
          val: 165
        },
        {
          year: 'Future',
          val: 265
        }
      ];
  const [chart, setChart] = React.useState();
  React.useEffect(() => {
    const newchart = initChart(chartRef.current, defaultData, props.numInital);
    setChart(newchart);
  }, []);
  React.useEffect(() => {
    if (chart) {
      //   const newchart = initChart(chartRef.current, props.data, props.numInital);
      chart.data = props.data;
      // setChart(newchart);
    }
  }, [props.data]);

  return (
    <div className="bar-chart-wrapper">
      <div
        ref={chartRef}
        id="chartdiv"
        className="chartdiv bar-chart-chart"
      ></div>
      <div className="bar-chart-label-wrapper">
        <div className="bar-chart-col-label">{esriStrings.barchartCurrent}</div>
        <div className="bar-chart-col-label">{esriStrings.barchartFuture}</div>
      </div>
      <div className="bar-chart-label">{props.chartLabel}</div>
    </div>
  );
};
BarChart.updateData = (newData) => {};
export default BarChart;
